import { userQuery } from "@common/api/users"
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@common/components/ui/dialog"
import { useSuspenseQuery } from "@tanstack/react-query"
import { createFileRoute, useNavigate } from "@tanstack/react-router"
import { ChangePasswordContent } from "@/routes/_layout/settings/-components/user-edit-card"
import { displayName } from "../../-lib/display-name"

export const Route = createFileRoute(
  "/_layout/settings/_panel/workspace/members/_list/$userId/change-password",
)({
  component: ChangePasswordDialog,
})

function ChangePasswordDialog(): React.ReactElement {
  const { userId } = Route.useParams()
  const { data: user } = useSuspenseQuery(userQuery({ user_id: userId }))
  const navigate = useNavigate()
  const close = () =>
    navigate({
      to: "/settings/workspace/members/$userId",
      params: { userId },
      search: true,
    })

  return (
    <Dialog open onOpenChange={(open) => !open && close()}>
      <DialogContent className="sm:max-w-lg">
        <DialogHeader>
          <DialogTitle>Reset password</DialogTitle>
          <DialogDescription>
            Set a new password for {displayName(user)}.
          </DialogDescription>
        </DialogHeader>
        <ChangePasswordContent userId={userId} onChanged={close} />
      </DialogContent>
    </Dialog>
  )
}
